<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Preshared Key</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Preshared Key</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="col-md-6">
        <div class="card">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <div class="card-body">
            <form
              class="form-row"
              name="ajax-contact-form"
              id="ajax-contact-form"
              @submit.prevent="handleSubmission()"
              method="POST"
              autocomplete="off"
              action="javascript:void(0)"
            >
              <div class="col-md-12">
                <div v-if="organizationId == 1" class="form-group">
                  <label class="control-label">Audra Name</label>
                  <multiselect
                    v-model="value.accountId"
                    :options="Object.keys(pre.audraName)"
                    :custom-label="opt => pre.audraName[opt]"
                    placeholder="Select Audra Name"
                    :searchable="true"
                    :multiple="false"
                    id="accountId"
                    v-bind:class="{ 'has-error': errors.has('accountId') }"
                    v-validate="'required'"
                    name="accountId"
                  >
                  </multiselect>
                  <div
                    class="help text-danger"
                    v-show="errors.has('accountId')"
                  >
                    {{ errors.first('accountId') }}
                  </div>
                </div>
                <div class="form-group">
                  <label class="control-label">Preshared Key</label>
                  <div class="password">
                    <input
                      type="password"
                      class="form-control input"
                      autocomplete="new-password"
                      name="key"
                      v-model="value.key"
                      :type="showPassword ? 'text' : 'password'"
                    />
                    <span class="password-toggle" @click="togglePassword">
                      <i
                        :class="{
                          'icon-eye-off': showPassword,
                          'icon-eye': !showPassword
                        }"
                      ></i>
                    </span>
                  </div>
                  <div class="help text-danger" v-show="errors.has('key')">
                    {{ errors.first('key') }}
                  </div>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <button
                    class="btn btn-outline"
                    type="button"
                    value="Auto Generate!"
                    @click.prevent="generateRandomKey"
                  >
                    <i class="icon-refresh"></i> Auto Generate!
                  </button>
                  <button v-if="!is_edit" class="btn ml-auto">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'PresharedKey',
  metaInfo: {
    title: 'Preshared Key | Dotlines'
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},

    pre: {
      audraName: []
    },

    showPassword: false,
    password: null
  }),
  methods: {
    togglePassword () {
      this.showPassword = !this.showPassword
    },
    async handleSubmission () {
      const _this = this
      _this.is_loading = true // Set loader to true before starting validation
      try {
        const result = await _this.$validator.validateAll()
        if (result) {
          const api_url = '/pre_shared_key'
          const method = 'POST'

          await axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(response => {
              _this.$toaster.success(response.data.message)
            })
            .catch(errors => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message)
                _this.$setErrorsFromResponse(errors.response.data.errors)
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message)
                _this.$setErrorsFromResponse(errors.response.data)
              }
            })
        }
      } catch (error) {
        console.log(error)
      } finally {
        _this.is_loading = false // Reset loader to false after all operations
      }
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }

      try {
        const audraNameResponse = await CommonAPI.getAudraName(
          LocalStorage.get('accountId')
        )
        this.pre.audraName = audraNameResponse

        const keyResponse = await this.getKey()
        this.value.accountId = keyResponse.data.accountId
        this.value.key = keyResponse.data.value
        this.$forceUpdate()
      } catch (error) {
        console.log(error.response)
      } finally {
        this.is_loading = false
      }

      this.value.accountId = LocalStorage.get('accountId')
    },
    toggleShow () {
      this.showPassword = !this.showPassword
    },
    generateRandomKey () {
      const chars =
        '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const passwordLength = 12
      let rnd = ''
      for (let i = 0; i <= passwordLength; i++) {
        const randomNumber = Math.floor(Math.random() * chars.length)
        rnd += chars.substring(randomNumber, randomNumber + 1)
      }
      this.value.key = rnd
      this.$forceUpdate()
    },
    async getKey () {
      return new Promise((resolve, reject) => {
        axios
          .get('/get_preshared_key', {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  mounted () {
    this.initialize()
  },
  computed: {
    buttonLabel () {
      return this.showPassword ? 'Hide' : 'Show'
    }
  }
}
</script>
